import { Component } from 'react'
import { reportErrorToAdmin, normalizeErrorForReporting } from '../lib/errorReporting'

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    reportErrorToAdmin('ReactErrorBoundary', normalizeErrorForReporting(error), {
      componentStack: errorInfo?.componentStack || '',
    })
  }

  render() {
    if (this.state.hasError) {
      const err = this.state.error
      const isDev = import.meta.env.DEV
      return (
        <div style={{
          padding: 24,
          maxWidth: 600,
          margin: '40px auto',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          background: '#fef2f2',
          borderRadius: 12,
          border: '1px solid #fecaca',
        }}>
          <h2 style={{ margin: '0 0 12px', color: '#b91c1c' }}>Something went wrong</h2>
          <p style={{ margin: 0, color: '#991b1b' }}>
            An error occurred. Our team has been notified. Please try refreshing the page or contact support if the issue persists.
          </p>
          {isDev && err && (
            <pre style={{ marginTop: 16, padding: 12, background: '#1e293b', color: '#e2e8f0', borderRadius: 8, fontSize: 12, overflow: 'auto', maxHeight: 200 }}>
              {err.message}
              {err.stack && `\n\n${err.stack}`}
            </pre>
          )}
        </div>
      )
    }
    return this.props.children
  }
}
